import { render, staticRenderFns } from "./MiElementPanelItem.vue?vue&type=template&id=7a235c0c&"
import script from "./MiElementPanelItem.vue?vue&type=script&lang=ts&"
export * from "./MiElementPanelItem.vue?vue&type=script&lang=ts&"
import style0 from "@/components/MiElementPanelItem/mi-element-panel-item.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports